// extracted by css-extract-rspack-plugin
export default {"transparentButton":"transparentButton-WyMAkI","iconSize":"iconSize-FGe6Ti"};